<template>
  <section class="t-navigation__menu">
    <button
      type="button"
      ref="menuButton"
      class="t-navigation__menu__button"
      aria-controls="menu"
      aria-haspopup="true"
      title="打開或關閉菜單"
      :aria-label="menuLabelMessage"
      :aria-expanded="menuExpandStatus"
      @click="toggleMenu"
    >
      <img
        :src="menubarLightSvg"
        :alt="menuLabelMessage"
        class="t-navigation__menu__image"
      />
    </button>
    <section class="t-navigation__menu__popup" ref="menu">
      <ul class="t-navigation__menu__links" @click="toggleMenu">
        <!-- 廟宇導覽 logo -->
        <li
          class="t-navigation__menu__item t-navigation__menu__item--temple"
          v-if="!isFestivalYear && windowWidth >= 1024"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ path: '/' }"
            title="[前往]廟宇宗教首頁"
            aria-label="[前往]廟宇宗教首頁"
          >
            <img
              :src="require(`@/assets/images/logo_new@2x.png`)"
              alt="[前往]廟宇宗教首頁"
            />
          </router-link>
        </li>

        <!-- 香科年 logo -->
        <li
          class="t-navigation__menu__item t-navigation__menu__item--festival"
          v-if="isFestivalYear && windowWidth >= 1024"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ name: 'festivalYear' }"
            title="[前往]香科年活動首頁"
            aria-label="[前往]香科年活動首頁"
          >
            <img
              :src="require(`@/assets/images/logo_festival.svg`)"
              alt="[前往]香科年活動首頁"
            />
          </router-link>
        </li>

        <li
          class="t-navigation__menu__item t-navigation__menu__item--main"
          v-for="(link, index) in navigationRoutes"
          :key="index"
          :id="link.id ? `${link.id}-link` : ''"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="link.routeTo"
            :title="`[前往]${link.ariaLabel}`"
            :aria-label="link.ariaLabel"
          >
            {{ link.ariaLabel }}
          </router-link>
        </li>

        <!-- 香科年 前往廟宇連結 -->
        <li
          class="t-navigation__menu__item t-navigation__menu__go-back"
          v-if="isFestivalYear"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ path: '/' }"
            title="[前往]廟宇宗教首頁"
            aria-label="[前往]廟宇宗教首頁"
          >
            <img :src="mainTempleSiteSvg" alt="[前往]廟宇宗教首頁" />
          </router-link>
        </li>

        <!-- 我的收藏 -->
        <li v-if="isLogin && !isFestivalYear" class="t-navigation__menu__item">
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ name: 'favourite' }"
            aria-label="我的收藏"
            title="[前往]我的收藏"
          >
            我的收藏
          </router-link>
        </li>
        <!-- 登入 -->
        <li
          class="t-navigation__menu__item t-navigation__menu__item--member"
          v-if="!isLogin && !isFestivalYear"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ name: 'login' }"
            aria-label="會員登入頁"
            title="[前往]會員登入頁"
          >
            登入
          </router-link>
        </li>
        <!-- 登出 -->
        <li
          class="t-navigation__menu__item t-navigation__menu__item--member"
          v-if="isLogin && !isFestivalYear"
        >
          <a
            @click="logout"
            :tabindex="isLinkFocusable"
            aria-label="會員登出"
            title="[前往]會員登出"
          >
            登出
          </a>
        </li>

        <!-- 搜尋 -->
        <li
          class="t-navigation__menu__item t-navigation__menu__item--search"
          v-if="!isFestivalYear"
        >
          <router-link
            :tabindex="isLinkFocusable"
            :to="{ name: 'searchInput' }"
            aria-label="搜尋"
            title="[前往]搜尋頁"
          >
            搜尋
          </router-link>
        </li>

        <!-- 英語，因局處沒提供內容，暫先取消-->
        <!-- 語言區塊 -->
        <!-- <section class="t-navigation__menu__language">
          <router-link
            class="t-navigation__menu__item"
            :tabindex="isLinkFocusable"
            :to="{ name: 'english' }"
            :aria-label="'英文導覽頁'"
          >
            <img
              :src="require(`@/assets/images/menu/english-link@2x.png`)"
              :srcset="
              require(`@/assets/images/menu/english-link.png`) +
                ' 1x, ' +
                require(`@/assets/images/menu/english-link@2x.png`) +
                ' 2x'
            "
              :alt="''"
            />
          </router-link>

          <router-link
            class="t-navigation__menu__item"
            :tabindex="isLinkFocusable"
            :to="{ name: 'japanese' }"
            :aria-label="'英文導覽頁'"
          >
            <img
              :src="require(`@/assets/images/menu/japanese@2x.png`)"
              :srcset="
              require(`@/assets/images/menu/japanese.png`) +
                ' 1x, ' +
                require(`@/assets/images/menu/japanese@2x.png`) +
                ' 2x'
            "
              :alt="''"
            />
          </router-link>
        </section>-->
      </ul>
      <button
        class="t-navigation__menu__close-layer"
        title="打開或關閉菜單"
        :aria-label="menuLabelMessage"
        :tabindex="isLinkFocusable"
        @click="toggleMenu"
      ></button>
    </section>
  </section>
</template>

<script>
import menubarSvg from "@/assets/images/menu/menu.svg";
import menubarLightSvg from "@/assets/images/menu/menu-light.svg";
import mainTempleSiteSvg from "@/assets/images/menu/go-back-to-main-site.svg";

export default {
  name: "NavigationMenu",
  props: {
    isHomePath: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // anchorNavigationRoutes: [
      //   // { routeTo: { path: '/' }, id: 'home', ariaLabel: '首頁' },
      //   {
      //     routeTo: '#temples',
      //     id: 'temples',
      //     ariaLabel: '參觀總覽',
      //   },
      //   {
      //     routeTo: '#artworks',
      //     id: 'artworks',
      //     ariaLabel: '藝品導覽',
      //   },
      //   { routeTo: '#themes', id: 'themes', ariaLabel: '旅遊導覽' },
      //   { routeTo: '#albums', id: 'albums', ariaLabel: '圖鑑集' },
      //   { routeTo: '#tags', id: 'tags', ariaLabel: '標籤檢索' },
      //   {
      //     routeTo: { name: 'festivalYear' },
      //     id: 'festival-year',
      //     ariaLabel: '香科年專區',
      //   },
      // ],
      homeNavigationRoutes: [
        // { routeTo: { path: '/' }, id: 'home', ariaLabel: '首頁' },
        {
          routeTo: { name: "temples" },
          id: "temples",
          ariaLabel: "參觀總覽",
        },
        {
          routeTo: { name: "artworks" },
          id: "artworks",
          ariaLabel: "藝品導覽",
        },
        {
          routeTo: { name: "themes" },
          id: "themes",
          ariaLabel: "旅遊導覽",
        },
        {
          routeTo: { name: "albums" },
          id: "albums",
          ariaLabel: "圖鑑集",
        },
        {
          routeTo: { name: "tags" },
          id: "tags",
          ariaLabel: "標籤檢索",
        },
        {
          routeTo: { name: "sitemap" },
          id: "sitemap",
          ariaLabel: "網站導覽",
        },
        {
          routeTo: { name: "festivalYear" },
          id: "festival-year",
          ariaLabel: "香科年專區",
        },
      ],
      festivalYearRoutes: [
        {
          routeTo: { name: "festivalYearFestivalList" },
          ariaLabel: "香科年介紹",
        },
        // {
        //   routeTo: { name: "festivalYearSkillList" },
        //   ariaLabel: "相關課程",
        // },
        {
          routeTo: { name: "festivalYearInformationList" },
          ariaLabel: "活動資訊",
        },
        {
          routeTo: { name: "festivalYearHistory" },
          ariaLabel: "歷史回顧",
        },
        // {
        //   routeTo: { name: "festivalYearNewsList" },
        //   ariaLabel: "最新消息",
        // },
        {
          routeTo: { name: "festivalYearEnglishList" },
          ariaLabel: "English",
        },
      ],
      menuExpandStatus: "false",
    };
  },
  computed: {
    mainTempleSiteSvg() {
      return mainTempleSiteSvg;
    },
    menubarSvg() {
      return menubarSvg;
    },
    menubarLightSvg() {
      return menubarLightSvg;
    },
    newExpandStatus() {
      return this.menuExpandStatus === "false" ? "true" : "false";
    },
    menuLabelMessage() {
      return this.menuExpandStatus === "false"
        ? "開啟網站主選單"
        : "關閉網站主選單";
    },
    isLinkFocusable() {
      // 1440 breakpoints 即不顯示漢堡，所以 nav links 都需要可被 tab
      if (this.windowWidth >= 1440) return "0";
      return this.menuExpandStatus === "false" ? "-1" : "0";
    },
    isLogin() {
      return this.$store.getters.getLoginStatus;
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
    navigationRoutes() {
      if (this.isFestivalYear) {
        return this.festivalYearRoutes;
      }

      // if (this.isHomePath) {
      //   if (this.windowWidth < 768) {
      //     return this.homeNavigationRoutes.filter(
      //       (link) => link.routeTo.path !== '/'
      //     );
      //   }

      //   return this.homeNavigationRoutes;
      // } else {
      //   if (this.windowWidth < 768) {
      //     return this.anchorNavigationRoutes.filter(
      //       (link) => link.routeTo.path !== '/'
      //     );
      //   }
      //   return this.anchorNavigationRoutes;
      // }

      return this.homeNavigationRoutes;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
  },
  methods: {
    // 為了可以重複觸發anchor
    reAnchor(next_hash) {
      const current_hash = location.hash;
      if (current_hash === next_hash) {
        location.hash = "";
        location.hash = current_hash;
      }
    },
    toggleMenu() {
      const menuAriaExpanded =
        this.$refs.menuButton.getAttribute("aria-expanded");

      this.menuExpandStatus = menuAriaExpanded === "false" ? "true" : "false";
      this.$refs.menu.classList.toggle("open");
    },
    logout() {
      window.alert("已登出，重新跳轉頁面");
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.t-navigation__menu {
  position: relative;
  z-index: getLayerIndex(menu);

  .t-navigation__menu__language {
    position: relative;
    width: 130px;
    margin-left: auto;

    @include for-desktop {
      position: absolute;
      display: flex;
      right: 0;
      top: 49px;
      width: 260px;
    }
  }

  &__button {
    @extend %no-select;
    height: 85%;
    padding: 0 14px;
    cursor: pointer;
    height: 48px;
    @include button-theme(fake);

    @include for-desktop {
      display: none;
    }
  }

  &__image {
    width: 20px;
  }

  &__popup {
    position: absolute; /* 向 menu button 對齊 */
    top: 100%;
    left: -2.5vw;
    width: 0;
    height: 100vh;

    @include for-desktop {
      width: 100vw;
      height: 0;
    }

    &.open {
      width: 100vw;
      height: 100vh;

      @include for-desktop {
        height: 0;
      }

      .t-navigation__menu__links {
        left: 0;
        padding: 0;
        margin: 0;
      }

      .t-navigation__menu__close-layer {
        left: 0;
        opacity: 1;
      }
    }
  }

  &__links {
    position: relative;
    z-index: 1;
    max-width: 180px;
    width: 100vw;
    height: 100%;
    left: -120vh;
    transition: left ease-in 0.1s;

    @include for-desktop {
      height: 65px;
      width: 100vw;
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      left: 0;
      top: -83px;
      border-bottom: 1px solid $color-border;
      margin: 0;
      padding-left: 0;
      width: 800px;
    }
  }

  &__item {
    position: relative;
    z-index: 1;
    display: block;
    margin-bottom: 1px; /* 為了不擋住 outline */
    margin-left: 1px; /* 為了不擋住 outline */
    color: $color-light-link;

    // ! 箭頭圖案，在手機版是 a 當背景，平板版以上是 a::after 當背景

    &:first-child {
      @include for-desktop {
        a::after {
          display: none;
        }
      }
    }

    &--temple {
      @include for-desktop {
        top: -2px;
        margin-right: 20px !important;
      }

      @include for-desktop {
        margin-right: 47px !important;
      }

      img {
        @include for-desktop {
          height: 30px;
        }

        @include for-desktop {
          width: 184px;
          height: 41px;
        }
      }
    }

    &--festival {
      @include for-desktop {
        margin-right: 10px !important;
      }

      @include for-desktop {
        margin-right: 25px !important;
      }

      img {
        height: 17px;

        @include for-desktop {
          height: auto;
        }
      }
    }

    &--member {
      background: url("../assets/images/member-system/btn_login.svg") right 16px
        center no-repeat;

      @include for-desktop {
        right: 35px;
      }

      @include for-desktop {
        right: 90px;
      }
    }

    &--search {
      background: url("../assets/images/menu/btn_search.svg") right 16px center
        no-repeat;

      @include for-desktop {
        right: -10px;
      }
    }

    a {
      font-size: 1.2rem;

      @include for-desktop {
        font-size: 1.125rem;
      }

      @include for-desktop {
        font-size: 1.375rem;
      }
    }

    &--member,
    &--search {
      background-size: 36px 36px;

      @include for-desktop {
        background-position: center;
        background-size: 30px 30px;
        position: fixed;
        top: 45px;
        width: 45px;
        margin: 0;
      }

      @include for-desktop {
        background-position: right 0 center;
        background-size: 36px 36px;
        width: 85px;
      }

      a {
        background: none !important;

        @include for-desktop {
          font-size: 0;

          &::after {
            display: none;
          }
        }

        @include for-desktop {
          font-size: 1.125rem;
        }
      }
    }

    img {
      /* 香科年選單裡的回到廟宇首頁 */
      display: inline-block;
      vertical-align: middle;
      position: relative;
      max-width: 100%;
      top: -3px;
      left: -2px;
      width: 182px;
      height: 39px;

      @include for-desktop {
        top: 0;
        left: 0;
      }
      @include for-tablet {
        width: auto;
        height: 32px;
      }
    }

    &:last-child {
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: $color-light-border;
      }
      @include for-desktop {
        &::after {
          display: none;
        }
      }
    }
  }

  &__item + &__item {
    @include for-desktop {
      border-left: 1px solid rgba($color-border, 0.2);
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: $color-light-border;
    }
  }

  &__close-layer {
    @include button-theme(fake);
    position: absolute; /* 向 popup 對齊 */
    top: -50px;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: $color-menu-layer-bg;
    opacity: 0;
    transition: opacity ease-in 0.05s;
    padding: 0;

    @include for-desktop {
      display: none;
    }
  }
}

#sitemap-link {
  @include for-desktop {
    display: none;
  }
}
</style>
